import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/auth";
import { Icon } from "@/components/kit";
import { toast } from "sonner";

const TABS = [
  { key: "whatsapp", label: "WhatsApp", icon: "MessageCircle" },
  { key: "linkedin", label: "LinkedIn", icon: "Linkedin" },
  { key: "starter", label: "Talking point", icon: "Quote" },
];

export default function DailyContent() {
  const nav = useNavigate();
  const [d, setD] = useState(null);
  const [tab, setTab] = useState("whatsapp");

  useEffect(() => { api.get("/content/today").then((r) => setD(r.data)).catch((e) => console.error("content today:", e)); }, []);
  if (!d) return null;

  const text = (d[tab] || "").replaceAll("{{YourName}}", d.for_name || "");
  const copy = () => {
    navigator.clipboard?.writeText(text);
    toast.success("Copied — ready to paste", { description: tab === "whatsapp" ? "Fill in {{ClientName}} and send in WhatsApp." : "Paste into your post." });
  };

  return (
    <div className="card-mfx p-5 mt-4" data-testid="daily-content">
      <div className="flex items-center gap-2 mb-1">
        <Icon name="Wand2" size={18} className="text-violet-400" />
        <h3 className="font-head font-semibold text-slate-100">Today's Investor Content</h3>
        <span className="text-[10px] font-bold bg-violet-500/12 text-violet-300 rounded-full px-2 py-0.5">Ready to send</span>
        <button onClick={() => nav("/app/content")} data-testid="daily-content-studio" className="ml-auto text-sm font-semibold text-amber-400 flex items-center gap-1">Personalize <Icon name="ChevronRight" size={14} /></button>
      </div>
      <p className="text-sm text-slate-400 mb-3">{d.topic}</p>

      <div className="flex gap-2 mb-3">
        {TABS.map((t) => (
          <button key={t.key} onClick={() => setTab(t.key)} data-testid={`daily-content-tab-${t.key}`}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium border transition-colors ${tab === t.key ? "grad-amber text-black border-transparent" : "bg-[#141822] border-[#2E384D] text-slate-400 hover:text-slate-200"}`}>
            <Icon name={t.icon} size={14} /> {t.label}
          </button>
        ))}
      </div>

      <div className="rounded-xl bg-[#0E1117] border border-[#222938] p-4 text-sm text-slate-200 whitespace-pre-wrap leading-relaxed max-h-56 overflow-y-auto" data-testid="daily-content-text">{text}</div>

      <div className="flex items-center gap-2 mt-3">
        <button onClick={copy} data-testid="daily-content-copy" className="grad-amber text-black font-semibold px-4 py-2.5 rounded-xl text-sm inline-flex items-center gap-2 amber-glow hover:brightness-105 transition">
          <Icon name="Copy" size={15} /> {tab === "whatsapp" ? "Copy for WhatsApp" : "Copy"}
        </button>
        <span className="text-[11px] text-slate-500 flex items-start gap-1.5"><Icon name="ShieldAlert" size={12} className="mt-0.5 shrink-0" />{d.disclaimer}</span>
      </div>
    </div>
  );
}
